import { gql } from "@apollo/client";

export const GET_EXCLUDED_DOMAINS = gql`
  query excludedDomains {
    excludedDomains
  }
`;